import styled from "styled-components";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import { ifProp, theme } from "styled-tools";

export const ButtonStyled = styled.button<{
  colorButton?: string;
  variant?: string;
}>`
  background: ${(props) =>
    props.colorButton ? theme(props.colorButton) : theme("Maximum_Yellow_Red")};
  width: 263px;
  border-radius: 30px;
  border: 0;
  padding: 8px 32px;
  margin-bottom: 100px;
  cursor: pointer;
  ${(props) => {
    if (props.variant === "outline") {
      return `
        background: white;
        border: 1px solid ${theme("Primary_600")};
        color: ${theme("Primary_600")};
        span {
          color: ${theme("Primary_600")};
        }
    `;
    }
  }};
`;

export const TextContainer = styled.div<{
  iconButton?: string;
  iconButtonLeft?: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  span {
    width: ${ifProp("!iconButton" && "!iconButtonLeft", "100%", "")};
    text-align: ${ifProp("!iconButton", "center", "right")};
    padding-left: 10px;
    padding-right: 10px;
    font-size: 20px;
    font-family: Poppins;
    font-weight: 600;
    line-height: 100%;
    color: ${theme("Lotion")};
    ${mediaQuery[Screen.xs]} {
      font-size: 20px;
      padding: 0;
    }
  }

  div {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
